import React from "react";
import Formsy from "formsy-react";
import Toaster from "toastr";
import Util from "../../../../util/util";
import Messages from "../../../../configurations/messages";
import CardHolderDetails from "./CreateCaseForms/CardHolderDetails";
import Documents from "./CreateCaseForms/Documents";
import { ReasonSpecifDetail as ReasonDetails } from "../../../../configurations/discoverConfigs/reasonCodes";
import { MotiveSpecifDetail } from "../../../../configurations/discoverConfigs/motiveCodes";
import ReasonSpecificDetail from "./CreateCaseForms/ReasonSpecificDetail";
import ConfirmCaseDetails from "./CreateCaseForms/Confirmation";
import Response from "./CreateCaseForms/Response";
import DiscoverApi from "../../../../api/DiscoverApi";
import { DiscoverFields } from "../../../../configurations/discoverConfigs/fields";
import { DiscoverConstants } from "../../../../configurations/discoverConfigs/discoverConstants";
import { fieldsConfig } from "../../../../configurations/discoverConfigs/commonFieldsConfig";
import InputControls from "../../common/InputControls";

const initialState = {
  reasonCodes: [],
  motiveCodes: [],
  selectedReasonCode: "",
  selectedMotiveCode: "",
  canSubmit: true,
  step: 1,
  fetchingReasonCodes: false,
  fetchingDuplicateTransactions: false,
  sending: false,
  caseInitiationError: null,
  duplicateTransactions: null,
  caseRequestObject: null,
  caseSuccessfulResponse: null,
  formData: {}
};

class CaseInitiation extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateFormState = this.updateFormState.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.exitCaseCreation = this.exitCaseCreation.bind(this);
    this.resetCaseCreation = this.resetCaseCreation.bind(this);
    this.onReasonCodeChange = this.onReasonCodeChange.bind(this);
    this.onMotiveCodeChange = this.onMotiveCodeChange.bind(this);
    this.getReasonCodes = this.getReasonCodes.bind(this);
    this.createCaseRequestObject = this.createCaseRequestObject.bind(this);
    this.getBase64 = this.getBase64.bind(this);
    this.getDuplicateTransactions = this.getDuplicateTransactions.bind(this);
    this.state = {
      ...initialState,
      formData: props.inboundRequest || {},
      selectedReasonCode:
        props.inboundRequest && props.inboundRequest.reasonCode
          ? props.inboundRequest.reasonCode
          : "",
      selectedMotiveCode:
        props.inboundRequest && props.inboundRequest.disputeMotiveId
          ? props.inboundRequest.disputeMotiveId
          : ""
    };
  }

  getReasonCodes() {
    const { transactionDetails } = this.props;
    const { formData } = this.state;
    let motiveCodes = [];
    const transactionParams = {
      transactionReference: transactionDetails.transactionReference,
      documentationIndicator: formData.documentationIndicator
        ? formData.documentationIndicator
        : 4,
      cashOverOption: formData.cashOverOption
    };
    this.setState({ ...this.state, fetchingReasonCodes: true });
    DiscoverApi.getDiscoverReasonCodes(transactionParams)
      .then(response => {
        let data = response.data;
        if (
          data &&
          this.state.selectedReasonCode &&
          this.state.selectedMotiveCode
        ) {
          const reasonCodeObject = data.filter(
            reasonCode =>
              reasonCode.reasonCode === this.state.selectedReasonCode
          );
          motiveCodes =
            reasonCodeObject &&
            reasonCodeObject.length &&
            reasonCodeObject[0].motiveCodes;
        }
        this.setState({
          ...this.state,
          reasonCodes: data,
          fetchingReasonCodes: false,
          motiveCodes
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, null, [
          `${Messages.ERROR_REASON_CODES}`
        ]);
        this.setState({ ...this.state, fetchingReasonCodes: false });
      });
  }

  getDuplicateTransactions() {
    const { transactionDetails } = this.props;
    const {
      transactionDate,
      pan,
      merchantCode,
      settlementAmount,
      settlementCurrencyCode
    } = transactionDetails;

    let settlementAmountAsFloat = settlementAmount.substring(4);
    settlementAmountAsFloat = parseFloat(
      settlementAmountAsFloat.replace(/,/g, "")
    );

    const duplicateRequestObject = {
      transactionDate,
      pan,
      merchantCode,
      settlementAmount: settlementAmountAsFloat,
      settlementCurrencyCode
    };

    this.setState({
      ...this.state,
      fetchingDuplicateTransactions: true
    });

    DiscoverApi.getDuplicateTransactions(duplicateRequestObject)
      .then(response => {
        const data = response.data;
        this.setState({
          ...this.state,
          fetchingDuplicateTransactions: false,
          duplicateTransactions: data
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, null, [
          `${Messages.ERROR_DUPLICATE_TRANSACTIONS}`
        ]);
        this.setState({ ...this.state, fetchingDuplicateTransactions: false });
      });
  }

  onReasonCodeChange(selectedOption) {
    let selectedReasonCode = "";
    let motiveCodes = [];
    let resetDuplicates = {};
    if (selectedOption) {
      selectedReasonCode = this.state.reasonCodes.find(
        code => code.reasonCode === selectedOption.reasonCode
      );
      const reasonDetailObject =
        ReasonDetails[
          `reasonDetail${selectedReasonCode && selectedReasonCode.reasonCode}`
        ];
      if (
        selectedReasonCode &&
        reasonDetailObject &&
        (reasonDetailObject.isDuplicate || reasonDetailObject.isRecurrent)
      ) {
        resetDuplicates.fetchingDuplicateTransactions = true;
        this.getDuplicateTransactions();
      } else {
        resetDuplicates.duplicateTransactions = null;
        resetDuplicates.fetchingDuplicateTransactions = false;
      }
    }
    if (
      selectedReasonCode.motiveCodes &&
      selectedReasonCode.motiveCodes.length
    ) {
      motiveCodes = selectedReasonCode.motiveCodes;
    }

    this.setState({
      ...this.state,
      ...resetDuplicates,
      selectedReasonCode: selectedReasonCode.reasonCode,
      selectedMotiveCode: "",
      motiveCodes,
      formData: {
        ...this.state.formData,
        disputeMotiveId: ""
      }
    });
  }

  onMotiveCodeChange(selectedOption) {
    let selectedMotiveCode = "";
    let resetDuplicates = {};
    if (selectedOption) {
      selectedMotiveCode = selectedOption.disputeMotiveId;
      const motiveDetailObject =
        MotiveSpecifDetail[`motiveDetail${selectedMotiveCode}`];
      if (
        selectedMotiveCode &&
        motiveDetailObject &&
        (motiveDetailObject.isDuplicate || motiveDetailObject.isRecurrent)
      ) {
        resetDuplicates.fetchingDuplicateTransactions = true;
        this.getDuplicateTransactions();
      } else {
        resetDuplicates.duplicateTransactions = null;
        resetDuplicates.fetchingDuplicateTransactions = false;
      }
    }
    this.setState({
      ...this.state,
      selectedMotiveCode,
      ...resetDuplicates
    });
  }

  nextStep() {
    this.setState((prevState, props) => {
      if (prevState.step <= 4) {
        return { step: prevState.step + 1 };
      }
    });
  }

  previousStep() {
    this.setState((prevState, props) => {
      if (prevState.step > 1) {
        return { step: prevState.step - 1 };
      }
    });
  }

  disableButton() {
    this.setState({ ...this.state, canSubmit: false });
  }

  enableButton() {
    this.setState({ ...this.state, canSubmit: true });
  }

  updateFormState(data) {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        ...data
      }
    }));
  }

  exitCaseCreation() {
    this.props.cancelCaseCreation();
  }

  resetCaseCreation() {
    this.setState({ ...this.state, step: 1 }, () =>
      this.setState(initialState)
    );
  }

  getBase64(file, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = callback;
  }

  createCaseRequestObject(formData) {
    const {
      transactionReference,
      settlementAmount
    } = this.props.transactionDetails;
    const { duplicateTransactions } = this.state;

    let settlementAmountAsFloat;
    if (settlementAmount) {
      settlementAmountAsFloat = settlementAmount.substring(4);
      settlementAmountAsFloat = parseFloat(
        settlementAmountAsFloat.replace(/,/g, "")
      );
    }

    if (formData && !formData[DiscoverFields.disputeAmount.name]) {
      formData[DiscoverFields.disputeAmount.name] = settlementAmountAsFloat;
    }

    const reasonCodeObject =
      ReasonDetails[`reasonDetail${formData["reasonCode"]}`];
    const motiveCodeObject =
      MotiveSpecifDetail[`motiveDetail${formData["disputeMotiveId"]}`];

    const isDuplicateProcessing =
      (reasonCodeObject && reasonCodeObject.isDuplicate) ||
      (motiveCodeObject && motiveCodeObject.isDuplicate);
    const isRecurrentProcessing =
      (reasonCodeObject && reasonCodeObject.isRecurrent) ||
      (motiveCodeObject && motiveCodeObject.isRecurrent);

    let apiBody = {
      transactionReference,
      ...formData
    };

    if (
      duplicateTransactions &&
      duplicateTransactions.length &&
      (isDuplicateProcessing || isRecurrentProcessing)
    ) {
      // let duplicateTransactionReferences = duplicateTransactions;

    /*   if (isDuplicateProcessing && formData.originalTransactionReference) {
        duplicateTransactionReferences = duplicateTransactionReferences.filter(
          transaction => {
            return (
              transaction.transactionReference !==
              formData.originalTransactionReference
            );
          }
        );
      } */

      /* duplicateTransactionReferences = duplicateTransactionReferences.map(
        transaction => {
          return transaction.transactionReference;
        }
      ); */

      apiBody = {
        ...apiBody,
        duplicateTransactionReferences: []
      };
    }

    if (apiBody.image) {
      this.getBase64(formData.image, e => {
        apiBody = {
          ...apiBody,
          fileFormat: apiBody.image.type.split("/").pop(),
          base64EncodedImage: e.target.result.split(",").pop()
        };
        this.handleSubmit(apiBody);
      });
    } else {
      this.handleSubmit(apiBody);
    }
  }

  handleSubmit(data) {
    this.setState({
      ...this.state,
      sending: true,
      caseInitiationError: null,
      step: 5
    });
    let requestId = "";
    let requestTypeCode = "";
    const caseRequest = this.props.caseDetail || this.state.caseRequestObject;
    if (caseRequest) {
      requestId = caseRequest.id || caseRequest.requestId;
      requestTypeCode = caseRequest.requestTypeCode;
      requestTypeCode = requestTypeCode && requestTypeCode.toLowerCase();
      if (!requestTypeCode) {
        if (
          caseRequest.requestType ===
          DiscoverConstants.CaseRequestTypes.caseCreation
        ) {
          requestTypeCode = "cc";
        } else if (
          caseRequest.requestType ===
          DiscoverConstants.CaseRequestTypes.caseUpdate
        ) {
          requestTypeCode = "uc";
        }
      }
    }
    DiscoverApi.createCase(data, requestTypeCode, requestId)
      .then(response => {
        Toaster.success(Messages.SUCCESS_CASE_INITIATION);
        this.setState({
          ...this.state,
          sending: false,
          caseInitiationError: null,
          caseSuccessfulResponse: response && response.data
        });
      })
      .catch(error => {
        this.setState({
          ...this.state,
          sending: false,
          caseInitiationError: error.data,
          caseRequestObject: error.data,
          caseSuccessfulResponse: null
        });
        Util.errorMessageToast(Toaster, error.data.description, [
          `${Messages.ERROR_CASE_INITIATION}`
        ]);
      });
  }

  render() {
    const {
      formData,
      canSubmit,
      step,
      motiveCodes,
      reasonCodes,
      selectedMotiveCode,
      selectedReasonCode,
      fetchingReasonCodes,
      sending,
      caseInitiationError,
      fetchingDuplicateTransactions,
      duplicateTransactions,
      caseSuccessfulResponse
    } = this.state;
    const { transactionDetails } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-sm-4 text-left">
            <h4 className="bold">
              Step {step}
              <small> of 5</small>
            </h4>
          </div>
          {step !== 5 && (
            <div className="col-sm-8 text-right">
              <button
                className="btn btn-primary"
                onClick={e => {
                  if (window.confirm("Are you sure you want to reset?"))
                    this.resetCaseCreation();
                }}
              >
                Reset case creation
              </button>{" "}
              <button
                className="btn btn-warning"
                onClick={e => {
                  if (window.confirm("Are you sure you want to exit?"))
                    this.exitCaseCreation();
                }}
              >
                Exit case creation
              </button>
            </div>
          )}
        </div>

        <Formsy
          onValidSubmit={this.createCaseRequestObject}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
          onChange={this.updateFormState}
          ref="caseCreationForm"
          noValidate
        >
          {step === 4 && <ConfirmCaseDetails />}
          {(step === 1 || step === 4) && (
            <CardHolderDetails
              disableFields={step === 4 ? true : false}
              formData={formData}
            />
          )}
          {(step === 2 || step === 4) && (
            <Documents
              disableFields={step === 4 ? true : false}
              formData={formData}
            />
          )}

          {(step === 3 || step === 4) && (
            <ReasonSpecificDetail
              disableFields={step === 4 ? true : false}
              formData={formData}
              getReasonCodes={this.getReasonCodes}
              motiveCodes={motiveCodes}
              reasonCodes={reasonCodes}
              transactionDetails={transactionDetails}
              fetchingReasonCodes={fetchingReasonCodes}
              selectedMotiveCode={selectedMotiveCode}
              selectedReasonCode={selectedReasonCode}
              onReasonCodeChange={this.onReasonCodeChange}
              onMotiveCodeChange={this.onMotiveCodeChange}
              fetchingDuplicateTransactions={fetchingDuplicateTransactions}
              duplicateTransactions={duplicateTransactions}
              getDuplicateTransactions={this.getDuplicateTransactions}
            />
          )}

          {(step === 3 || step === 4) && (
            <div className="panel panel-default">
              <div className="panel-body">
                <div className="caseNotes">
                  <InputControls
                    field={fieldsConfig.caseNote}
                    formData={formData}
                    disableFields={step === 4 ? true : false}
                  />
                </div>
              </div>
            </div>
          )}

          {step === 4 && <ConfirmCaseDetails />}

          {step === 5 && (
            <Response
              errors={caseInitiationError}
              sending={sending}
              formData={formData}
              caseSuccessfulResponse={caseSuccessfulResponse}
            />
          )}

          <div className="row">
            <div className="col-xs-12">
              {step >= 1 && step < 4 && !fetchingReasonCodes && (
                <button
                  type="button"
                  disabled={!canSubmit}
                  className="btn btn-primary pull-right"
                  onClick={this.nextStep}
                >
                  Continue
                </button>
              )}
              {((step > 1 && step <= 4 && !fetchingReasonCodes) ||
                (step > 1 && caseInitiationError !== null)) && (
                <button
                  type="button"
                  className="btn btn-primary pull-left"
                  onClick={this.previousStep}
                >
                  Previous
                </button>
              )}
              {step === 4 && (
                <button
                  type="submit"
                  // disabled={!canSubmit}
                  className="btn btn-primary pull-right"
                >
                  Create new case
                </button>
              )}
            </div>
          </div>
        </Formsy>
      </div>
    );
  }
}

export default CaseInitiation;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CaseInitiation.js